import React from 'react';

import moment from 'moment';
import RCTimePicker from 'rc-time-picker';

const TimePicker = ({ value, ...props }) => (
  <RCTimePicker
    showSecond={false}
    format="h:mm a"
    use12Hours
    inputReadOnly
    value={moment(value)}
    {...props}
  />
);

export default TimePicker;
